import {LightboxImage} from './LightboxImage';
import {LightboxVideo} from './LightboxVideo';

export type LightboxSlide = ({type: 'video'} & LightboxVideo) | ({type: 'image'} & LightboxImage);
